/**
 * reducedMotion.ts — shared prefers-reduced-motion helpers for the web map
 * layer (PLA-262). One-shot read + change subscription; both are safe to call
 * in non-browser environments (native / jest), where they report "no
 * preference" and the subscription is a no-op.
 */

/** One-shot read of the user's prefers-reduced-motion setting (web). */
export function prefersReducedMotion(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false
  }
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches
}

/** Subscribes to prefers-reduced-motion changes; returns an unsubscribe. */
export function subscribeReducedMotion(onChange: (matches: boolean) => void): () => void {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return () => {}
  }
  const query = window.matchMedia("(prefers-reduced-motion: reduce)")
  const listener = (event: MediaQueryListEvent) => onChange(event.matches)
  if (typeof query.addEventListener === "function") {
    query.addEventListener("change", listener)
    return () => query.removeEventListener("change", listener)
  }
  // Legacy Safari (< 14) MediaQueryList API.
  query.addListener(listener)
  return () => query.removeListener(listener)
}
